<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t('bill.resource_tag')"
    icon="res-resource-tag"
    :res-name="detailData.name"
    :current-tab="params.windowData.currentTab"
    :loaded="loaded"
    :tabs="detailTabs"
    @tab-change="handleTabChange">
    <component :is="params.windowData.currentTab" :res-id="data.id" :data="detailData" :params="params" :resourceTagColumns="columns" />
  </base-side-page>
</template>

<script>
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import ColumnsMixin from '../mixins/columns'
import Detail from './Detail'
import Event from './Event'

export default {
  name: 'ResourceTagSidePage',
  components: {
    Detail,
    Event,
  },
  mixins: [SidePageMixin, WindowsMixin, ColumnsMixin],
  data () {
    return {
      detailTabs: [
        { label: this.$t('bill.text_185'), key: 'detail' },
        { label: this.$t('bill.event'), key: 'event' },
        { label: this.$t('compute.text_240'), key: 'event-drawer' },
      ],
    }
  },
  methods: {
  },
}
</script>
